/**
 * Panneau debug config: REACT_APP_IS_DEBUG au build (CRA / Netlify).
 * Valeurs acceptées: true, 1, yes (insensible à la casse, trim).
 * En développement uniquement: ajouter ?debugConfig=1 à l’URL si la variable n’est pas prise en compte (serveur non redémarré, etc.).
 */
export function isAppDebug() {
  const raw = process.env.REACT_APP_IS_DEBUG;
  const n = raw == null ? "" : String(raw).trim().toLowerCase();
  if (n === "true" || n === "1" || n === "yes" || n === "on") {
    return true;
  }
  if (process.env.NODE_ENV !== "development") {
    return false;
  }
  if (typeof window === "undefined") {
    return false;
  }
  try {
    return (
      new URLSearchParams(window.location.search).get("debugConfig") === "1"
    );
  } catch {
    return false;
  }
}
